import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  InputLabel,
  Grid,
  Typography,
  Slider
} from '@material-ui/core';

const cpuMarks = [
  {
    value: 2000,
    label: '2'
  },
  {
    value: 3000,
    label: '3'
  },
  {
    value: 4000,
    label: '4'
  },
  {
    value: 5000,
    label: '5'
  },
  {
    value: 6000,
    label: '6'
  },
  {
    value: 7000,
    label: '7'
  },
  {
    value: 8000,
    label: '8'
  }
];
const memoryMarks = [
  {
    value: 2000,
    label: '2000'
  },
  {
    value: 3000,
    label: '3000'
  },
  {
    value: 4000,
    label: '4000'
  },
  {
    value: 5000,
    label: '5000'
  },
  {
    value: 6000,
    label: '6000'
  },
  {
    value: 7000,
    label: '7000'
  },
  {
    value: 8000,
    label: '8000'
  }
];

// maps the disk size to the appropriate total M values for the particular LRU
const diskSizeMap = {
  small: 50000,
  medium: 100000,
  large: 500000,
  xlarge: 1000000
};

const resourceSizeMap = {
  small: 2000,
  medium: 4000,
  large: 6000,
  xlarge: 8000
};

const sizes = ['small', 'medium', 'large', 'xlarge', 'custom'];
export const diskSizes = ['small', 'medium', 'large', 'xlarge'];

const diskSizeMarkMap = {
  small: 1,
  medium: 2,
  large: 3,
  xlarge: 4
};

const diskMarkSizeMap = {
  1: 'small',
  2: 'medium',
  3: 'large',
  4: 'xlarge'
};

function getDiskMarks() {
  return [
    { value: 1, label: diskSizeMap.small / 1000 },
    { value: 2, label: diskSizeMap.medium / 1000 },
    { value: 3, label: diskSizeMap.large / 1000 },
    { value: 4, label: diskSizeMap.xlarge / 1000 }
  ];
}

function getDiskSize(diskSize) {
  return diskSizeMarkMap[diskSize];
}

function getResourcesSize(resourceSize) {
  return resourceSizeMap[resourceSize];
}

// returns the label depending of the size of the LRU
export function getSizeLabel(size) {
  if (size === 'small') {
    return `${size} (default)`;
  }
  return size;
}

VMSize.propTypes = {
  updateCurrentVM: PropTypes.func,
  currentVM: PropTypes.object
};

export function VMSize({ updateCurrentVM, currentVM }) {
  const setSize = (event) => {
    const s = event.target.value;

    // if not custom, update the disk, memory, and cpu size accordingly
    if (s !== 'custom') {
      const newVM = {
        ...currentVM,
        size: s,
        diskSize: s,
        memory: getResourcesSize(s),
        cpu: getResourcesSize(s)
      };
      updateCurrentVM(newVM);
    } else {
      const newVM = {
        ...currentVM,
        size: s
      };
      updateCurrentVM(newVM);
    }
  };

  const setDiskSize = (event) => {
    const newVM = { ...currentVM };
    newVM.diskSize = diskMarkSizeMap[event.target.value];
    updateCurrentVM(newVM);
  };

  const setMemoryLimit = (event) => {
    const newVM = { ...currentVM };
    newVM.memory = event.target.value;
    updateCurrentVM(newVM);
  };

  const setCPULimit = (event) => {
    const newVM = { ...currentVM };
    newVM.cpu = event.target.value;
    updateCurrentVM(newVM);
  };

  const isCustom = () => currentVM.size === 'custom';

  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormControl data-testid="vm-size">
          <InputLabel id="size-label">Instance Size</InputLabel>
          <Select
            labelId="size-label"
            label="Instance Size"
            value={currentVM.size}
            onChange={setSize}
            fullWidth
          >
            {sizes.map((el, i) => (
              <MenuItem key={i} value={el}>
                {getSizeLabel(el)}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>
            The instance size will affect the disk size and resource limits
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sx={{ ml: 2 }}>
        <Typography variant="subtitle2">Disk Size (GB)</Typography>
        <Slider
          aria-label="DiskSize"
          sx={{ marginLeft: 1.2, width: '100%', maxWidth: 400 }}
          marks={getDiskMarks()}
          max={getDiskMarks()[getDiskMarks().length - 1].value}
          min={getDiskMarks()[0].value}
          step={null}
          value={getDiskSize(currentVM.diskSize)}
          onChange={setDiskSize}
          disabled={!isCustom()}
          size="small"
        />
        <Typography variant="subtitle2">CPU Limit (# cores)</Typography>
        <Slider
          aria-label="CPULimit"
          sx={{ marginLeft: 1.2, width: '90%', maxWidth: 400 }}
          valueLabelDisplay="auto"
          marks={cpuMarks}
          max={cpuMarks[cpuMarks.length - 1].value}
          min={cpuMarks[0].value}
          step={null}
          value={currentVM.cpu}
          onChange={setCPULimit}
          disabled={!isCustom()}
          size="small"
        />
        <Typography variant="subtitle2">Memory Limit (MB)</Typography>
        <Slider
          aria-label="MemoryLimit"
          sx={{ marginLeft: 1.2, width: '90%', maxWidth: 400 }}
          valueLabelDisplay="auto"
          marks={memoryMarks}
          max={memoryMarks[memoryMarks.length - 1].value}
          min={memoryMarks[0].value}
          step={500}
          value={currentVM.memory}
          onChange={setMemoryLimit}
          disabled={!isCustom()}
          size="small"
        />
      </Grid>
    </Grid>
  );
}
